import { ChevronRight, FolderOpen, Folder } from "lucide-react";
import { textoTotais } from "../../../lib/unidadeVenda";
import CelulasValores from "./CelulasValores";

function Legenda(c) {
  if (c.semDados) return "";
  if (c.porItem) return "média/item";
  return "30 dias";
}

/** Linha-resumo da categoria: clica para abrir e ver os produtos. */
export default function LinhaCategoria({ c, aberta, onToggle }) {
  const Icone = aberta ? FolderOpen : Folder;
  // "12 un · 3,500 kg": quilo não se soma com unidade nem perde as casas (30/09/2026).
  const unidades = c.vendidosPorMedida ? textoTotais(c.vendidosPorMedida) : Math.round(c.unidades).toLocaleString("pt-BR");
  return (
    <tr
      onClick={onToggle}
      className={`border-t cursor-pointer select-none transition-colors ${aberta ? "bg-primary/5 hover:bg-primary/10" : "bg-muted/25 hover:bg-muted/45"}`}
      aria-expanded={aberta}
    >
      <td className="py-3 px-2 pl-4">
        <div className="flex items-center gap-2.5">
          <ChevronRight className={`w-4 h-4 text-muted-foreground transition-transform ${aberta ? "rotate-90" : ""}`} />
          <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
            <Icone className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <p className="font-bold truncate max-w-[240px] leading-tight">{c.name}</p>
            <p className="text-[10px] text-muted-foreground mt-0.5">
              {c.qtdProdutos} {c.qtdProdutos === 1 ? "produto" : "produtos"}
              {!c.porItem && c.unidades > 0 ? ` · ${unidades} vendidos em 30 dias` : ""}
              {c.porItem && !c.semDados ? (c.soldRevenue > 0 ? " · só itens sem ficha venderam em 30 dias" : " · sem vendas em 30 dias") : ""}
            </p>
            {c.semFicha > 0 && !c.semDados ? (
              <span className="inline-block mt-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-500/20">
                {c.semFicha} sem ficha técnica (fora da conta)
              </span>
            ) : null}
          </div>
        </div>
      </td>
      <CelulasValores linha={c} legenda={Legenda(c)} />
    </tr>
  );
}
